<template>
  <div class="columns is-vcentered">
    <div class="column desk-only">
      <img
          src="https://evgeshayoga.com/storage/files/shares/images/%D0%9F%D1%80%D1%8F%D0%BC%D0%BE%D1%83%D0%B3%D0%BE%D0%BB%D1%8C%D0%BD%D1%8B%D0%B5/twist-white.jpg"
          alt="" style="width: 100%">
    </div>
    <div class="column info-block mb-5 has-text-centered">
      <h2 class="is-uppercase has-text-weight-bold mb-2">Курсы</h2>
      <p class="has-text-justified">
        В этом разделе собраны тематические курсы с теорией и практикой. Полезное для себя найти могут как будущие
        мамочки, так и любители стоек на руках. Все курсы сайта имеют бессрочный доступ.
      </p>
      <a href="/marathons" class="button is-medium is-primary mt-4">Посмотреть все курсы</a>
    </div>
  </div>
  <div class="tile is-ancestor is-desktop mb-5">
    <MarathonCard v-for='(marathon, i) in marathons' :key="i" class="video" v-bind:marathon="marathon">
    </MarathonCard>
  </div>
</template>

<script>
import MarathonCard from "../components/MarathonCard";

export default {
  name: 'MarathonsContent',
  data: function () {
    return {
      marathons: window.vueData.marathons
    }
  },
  components: {
    MarathonCard
  }
}
</script>
